import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getSettings = async (estateId = "", estateParentId = "") => {
	const params = {};
	if (estateId) params.estate_id = estateId;
	if (estateParentId) params.estate_parent_id = estateParentId;

	const { data } = await axios.get(`${API}/app/maintainer/settings`, { params });
	return data;
};
